import { render } from "./Details.vue?vue&type=template&id=723c2310"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=723c2310&lang=css"

import exportComponent from "C:\\Users\\naska\\Desktop\\Javascript Portfolio Projects\\movie-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__